import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Icon, TableBody, TableRow, TableHead, Table, IconButton, DialogActions, Button, DialogContent, DialogContentText, DialogTitle, Dialog } from "@mui/material";
import { createObj, int32ToString, uncurry2, defaultOf } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { SnackAlert, SnackAlertLevel, SnackAlertLevel_$reflection, wrapTooltip, loadingIndicatorSmall, errorBanner } from "../../ViewHelpers.js";
import { cons, empty, ofArray } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { empty as empty_1, append, singleton, delay, toList } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { API_Document_DownloadCustomerAttachment, API_Document_CustomerAttachments, API_Document_CustomerAttachment } from "../../Shared/Urls.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Document$, Document$_$reflection, GenericResponse_$reflection } from "../../Shared/ApiDataTypes.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { testRedirect, extraCoders, corsProps } from "../../Promises.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { value as value_54, some, unwrap, map, defaultArg } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { array_type, record_type, option_type, string_type, obj_type } from "../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import Delete from "@mui/icons-material/Delete";
import { Record } from "../../fable_modules/fable-library-js.4.24.0/Types.js";
import { ViewMode, Message, dispatchCtx, documentsCtx } from "../../Documents/DocumentContext.js";
import { UploadModule_UploadForm, Upload_EditButton_13687765, UploadTarget } from "./Upload.js";
import { actionColumn, dateColumn, filenameCell, docTableButtonHeader, docTableTextHeader } from "../../Documents/DocumentHelpers.js";
import { map as map_1 } from "../../fable_modules/fable-library-js.4.24.0/Array.js";
import { toDateStr } from "../../Locale.js";
import { parse } from "../../fable_modules/fable-library-js.4.24.0/Date.js";
import { getFiles, testDragLeave } from "../../Utils.js";
import FolderOpen from "@mui/icons-material/FolderOpen";
import Folder from "@mui/icons-material/Folder";
import Publish from "@mui/icons-material/Publish";

function DeleteForm(deleteFormInputProps) {
    let elements_2, children, children_1;
    const onClose = deleteFormInputProps.onClose;
    const document$ = deleteFormInputProps.document;
    const isOpen = deleteFormInputProps.isOpen;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const patternInput_1 = reactApi.useState(undefined);
    const setErrMsg = patternInput_1[1];
    const handleClose = (deletedDoc) => {
        setErrMsg(undefined);
        setProcessing(false);
        onClose(deletedDoc);
    };
    return MuiHelpers_createElement(Dialog, [["open", isOpen], ["onClose", (_arg_3, v) => {
        handleClose(undefined);
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("Document.Delete")]]), (children = ofArray([MuiHelpers_createElement(DialogContentText, [["children", `${ctx.Locale.t("Document.DeleteDesc1", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["documentName", document$.Filename]))}`]]), errorBanner(patternInput_1[0], () => {
        setErrMsg(undefined);
    })]), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_1 = toList(delay(() => (patternInput[0] ? singleton(loadingIndicatorSmall()) : append(singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_5) => {
        handleClose(undefined);
    }]])), delay(() => singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["children", ctx.Locale.t("Delete")], ["onClick", (_arg_6) => {
        let properties_2;
        const url = API_Document_CustomerAttachment(document$.Guid);
        setProcessing(true);
        let pr_1;
        const decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined);
        const data_1 = undefined;
        const caseStrategy_2 = undefined;
        const extra_2 = undefined;
        try {
            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
            const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                let response_1, decoder_1_1;
                return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                    let matchValue;
                    return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
            }))));
            pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
        }
        catch (exn) {
            pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
        }
        pr_1.then((res) => {
            if (res.tag === 1) {
                console.error(some("Error deleting document"), res.fields[0]);
                setErrMsg(ctx.Locale.t("Document.DeleteFailed"));
            }
            else {
                const x_1 = res.fields[0];
                if (x_1.Result === "success") {
                    handleClose(document$);
                }
                else {
                    setErrMsg(x_1.Message);
                }
            }
            setProcessing(false);
        });
    }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_1))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function DeleteButton(deleteButtonInputProps) {
    let props_1;
    const onDeleted = deleteButtonInputProps.onDeleted;
    const document$ = deleteButtonInputProps.document;
    const text = deleteButtonInputProps.text;
    const patternInput = reactApi.useState(false);
    const setDialog = patternInput[1];
    const xs = [createElement(DeleteForm, {
        isOpen: patternInput[0],
        document: document$,
        onClose: (deletedDoc) => {
            onDeleted(deletedDoc);
            setDialog(false);
        },
    }), wrapTooltip(text, MuiHelpers_createElement(IconButton, [["onClick", (_arg) => {
        setDialog(true);
    }], ["size", "small"], ["children", (props_1 = {}, react.createElement(Delete, props_1))]]))];
    return react.createElement(react.Fragment, {}, ...xs);
}

export class Alert extends Record {
    constructor(Level, Msg) {
        super();
        this.Level = Level;
        this.Msg = Msg;
    }
}

export function Alert_$reflection() {
    return record_type("Components.Documents.CustomerAttachments.Alert", [], Alert, () => [["Level", SnackAlertLevel_$reflection()], ["Msg", option_type(string_type)]]);
}

/**
 * Document-tree component used to fetch, list and handle user-uploaded documents. These are fetched from a seperate database. This is also the only folder that regular users can upload documents to.
 */
export function TreeNode(treeNodeInputProps) {
    let elements_4, elements_1, elements, children;
    const machineId = treeNodeInputProps.machineId;
    const customerId = treeNodeInputProps.customerId;
    const key = treeNodeInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const model = reactApi.useContext(documentsCtx);
    const dispatch = reactApi.useContext(dispatchCtx);
    const patternInput = reactApi.useState(false);
    const setLoading = patternInput[1];
    const patternInput_1 = reactApi.useState(false);
    const setOpen = patternInput_1[1];
    const isOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setHovering = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const uploadForm = patternInput_3[0];
    const setUploadForm = patternInput_3[1];
    let patternInput_4;
    const initial_4 = new Alert(new SnackAlertLevel(2, []), undefined);
    patternInput_4 = reactApi.useState(initial_4);
    const setError = patternInput_4[1];
    const error = patternInput_4[0];
    const mainElemRef = reactApi.useRef(undefined);
    let patternInput_5;
    const matchValue = ctx.Session;
    if (matchValue != null) {
        const s = matchValue;
        const isAdmin = s.IsAdmin ? true : s.IsSuperAdmin;
        patternInput_5 = [isAdmin ? true : !s.IsPtg, s.IsPtg, isAdmin];
    }
    else {
        patternInput_5 = [false, false, false];
    }
    const isAdmin_1 = patternInput_5[2];
    const dependencies = [isOpen];
    reactApi.useEffect(() => {
        let properties_2;
        if (isOpen) {
            const url = API_Document_CustomerAttachments([["customer", int32ToString(customerId)], ["machine", defaultArg(map(int32ToString, machineId), "")]]);
            setLoading(true);
            let pr_2;
            let pr_1;
            const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Document$_$reflection()), undefined, undefined);
            const data_1 = undefined;
            const caseStrategy_2 = undefined;
            const extra_2 = extraCoders;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Document$_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue_1;
                        return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
            pr_2.then((res) => {
                setLoading(false);
                if (res.tag === 0) {
                    dispatch(new Message(10, [res.fields[0]]));
                }
                else {
                    console.error(some("Failed fetching customer documents:"), res.fields[0]);
                }
            });
        }
    }, dependencies);
    const target = (machineId != null) ? (new UploadTarget(0, [machineId])) : (new UploadTarget(1, [customerId]));
    const documentTable = MuiHelpers_createElement(Table, [["size", "small"], (elements_4 = [MuiHelpers_createElement(TableHead, [(elements_1 = [MuiHelpers_createElement(TableRow, [(elements = toList(delay(() => append(singleton(docTableTextHeader(ctx.Locale.t("Document.Document"))), delay(() => append(singleton(docTableTextHeader(ctx.Locale.t("History.Date"))), delay(() => append(singleton(docTableButtonHeader()), delay(() => (isAdmin_1 ? singleton(docTableButtonHeader()) : empty_1()))))))))), ["children", reactApi.Children.toArray(Array.from(elements))])])], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), (children = map_1((document$) => {
        let elements_2;
        const downloadUrl = API_Document_DownloadCustomerAttachment(document$.Guid);
        return MuiHelpers_createElement(TableRow, [(elements_2 = toList(delay(() => append(singleton(filenameCell(downloadUrl, document$, [])), delay(() => append(singleton(dateColumn(toList(delay(() => ((document$.Date != null) ? singleton(createElement("span", {
            children: [toDateStr(ctx.DateFnsLocale, parse(value_54(document$.Date)))],
        })) : empty_1()))))), delay(() => {
            let $key43282806;
            return append(singleton(actionColumn([($key43282806 = document$.Guid, createElement(Upload_EditButton_13687765, {
                key: $key43282806,
                $key: $key43282806,
                customerId: customerId,
                onClose: (updated) => {
                    dispatch(new Message(19, [updated]));
                },
                document: document$,
                customerAttachment: true,
            }))])), delay(() => (isAdmin_1 ? singleton(actionColumn([createElement(DeleteButton, {
                text: ctx.Locale.t("Document.Delete"),
                document: document$,
                onDeleted: (deletedDocOpt) => {
                    if (deletedDocOpt == null) {
                    }
                    else {
                        const deletedDoc = deletedDocOpt;
                        if (deletedDoc.IsDeleted) {
                            dispatch(new Message(8, [deletedDoc.Guid]));
                        }
                        else {
                            dispatch(new Message(19, [new Document$(deletedDoc.Guid, deletedDoc.Number, deletedDoc.CustomerId, deletedDoc.Title, deletedDoc.CategoryTreeId, deletedDoc.TypeId, deletedDoc.Machine, deletedDoc.SourceId, deletedDoc.Date, deletedDoc.Uploader, deletedDoc.IsHidden, true, deletedDoc.Version, deletedDoc.Uploaded, deletedDoc.ManuallyMoved, deletedDoc.ContentId, deletedDoc.Filename, deletedDoc.ContentSizeBytes, deletedDoc.Versions)]));
                        }
                    }
                },
            })])) : empty_1())));
        })))))), ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
    }, model.CustomerDocs.filter((doc) => {
        if (model.Filter.ShowDeleted) {
            return true;
        }
        else {
            return !doc.IsDeleted;
        }
    })), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children))]]))], ["children", reactApi.Children.toArray(Array.from(elements_4))])]);
    const xs_4 = toList(delay(() => append(singleton(createElement(SnackAlert, {
        key: "customer-attachment-snackbar",
        $key: "customer-attachment-snackbar",
        level: error.Level,
        msg: unwrap(error.Msg),
        dismiss: () => {
            setError(new Alert(error.Level, undefined));
        },
    })), delay(() => append((uploadForm != null) ? singleton(createElement(UploadModule_UploadForm, {
        target: target,
        customerId: customerId,
        customerAttachment: true,
        files: value_54(uploadForm),
        onClose: (newFiles) => {
            if (newFiles.length > 0) {
                dispatch(new Message(2, [newFiles]));
            }
            setUploadForm(undefined);
        },
    })) : empty_1(), delay(() => {
        let elems_8;
        return singleton(createElement("div", createObj(ofArray([["style", {
            width: 100 + "%",
        }], (elems_8 = [createElement("div", createObj(toList(delay(() => append(singleton(["ref", mainElemRef]), delay(() => append(model.Editing ? append(singleton(["onDragOver", (ev) => {
            ev.preventDefault();
        }]), delay(() => append(singleton(["onDragEnter", (ev_1) => {
            ev_1.preventDefault();
            console.debug("Entered drag area");
            setHovering(true);
            if (!isOpen) {
                setOpen(true);
            }
        }]), delay(() => append(singleton(["onDragLeave", (ev_2) => {
            ev_2.preventDefault();
            if (mainElemRef.current != null) {
                if (testDragLeave(value_54(mainElemRef.current), ev_2)) {
                    console.debug("Left drag area");
                    setHovering(false);
                }
            }
        }]), delay(() => singleton(["onDrop", (ev_3) => {
            ev_3.preventDefault();
            setHovering(false);
            if (isAdmin_1 ? true : !patternInput_5[1]) {
                const files = getFiles(ev_3.dataTransfer.files);
                if (files.length === 0) {
                    console.warn(some("onDrop without files"));
                }
                else {
                    setUploadForm(files);
                }
            }
            else {
                console.error(some("You are not allowed to upload customer documents"));
                setError(new Alert(new SnackAlertLevel(0, []), "Du kan ikke laste opp kundedokumenter"));
            }
        }]))))))) : empty_1(), delay(() => append(singleton(["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => (patternInput_2[0] ? singleton(["backgroundColor", "#B0E0E6"]) : (isOpen ? singleton(["backgroundColor", "rgba(98, 181, 229, 0.2)"]) : empty_1())))))))))]), delay(() => {
            let elems_7, elems_6;
            return singleton((elems_7 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                fontSize: 0.8 + "rem",
                width: 100 + "%",
            }], ["onClick", (_arg_2) => {
                setOpen(!isOpen);
                dispatch(new Message(9, [new ViewMode(2, [])]));
            }], (elems_6 = toList(delay(() => {
                let props_6, props_8;
                return append(singleton(MuiHelpers_createElement(Icon, [["style", {
                    color: "green",
                    marginRight: 5,
                }], ["children", patternInput[0] ? loadingIndicatorSmall() : (isOpen ? ((props_6 = {}, react.createElement(FolderOpen, props_6))) : ((props_8 = {}, react.createElement(Folder, props_8))))]])), delay(() => append(singleton(createElement("span", {
                    style: {
                        flexGrow: 1,
                        textDecorationLine: "underline",
                    },
                    children: ctx.Locale.t("Document.AttachmentFromCustomer"),
                })), delay(() => {
                    let elements_5, props_12;
                    return patternInput_5[0] ? singleton(MuiHelpers_createElement(IconButton, [["onClick", (ev_4) => {
                        ev_4.stopPropagation();
                        setUploadForm([]);
                    }], ["size", "small"], (elements_5 = [(props_12 = {
                        fontSize: "small",
                    }, react.createElement(Publish, props_12))], ["children", reactApi.Children.toArray(Array.from(elements_5))])])) : empty_1();
                }))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))]));
        }))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))));
    }))))));
    return react.createElement(react.Fragment, {}, ...xs_4);
}

